import {useMutation} from "@tanstack/react-query";

import {deleteMaterialMutationOptions} from "./delete-material.mutation-options";

export function useDeleteMaterial() {
  return useMutation(deleteMaterialMutationOptions());
}
